import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const appointmentDateTimeMachine = createTripArrayFieldMachine(
  'appointmentDateTime',
);
